import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TableHeadRowWrapper, TableHeadWrapper } from './styled';
export const TableHeadRow = React.memo(function TableHeadRow({ children, className, }) {
    return (_jsx(TableHeadWrapper, { className: className, children: _jsx(TableHeadRowWrapper, { children: children }) }));
});
